<script>
import {Choice} from '../Choice'
import RadioButtonControl from './RadioButtonControl'

export default {
  name: 'RadioButton',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String
    },
    error: {
      type: String
    },
    helpText: {
      type: String
    },
    /**
     * Radio buttons with the same name will form a group.
     */
    name: {
      type: String
    },
    /**
     * The bound value / v-model.
     */
    value: {
      type: null
    },
    /**
     * The model value to use when checked.
     */
    trueValue: {
      type: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  functional: true,
  render(h, {children, data, props, $style}) {
    const isChecked = props.value === props.trueValue
    const controlMarkup = h('div', {
      class: $style.RadioButton
    }, [
      h(RadioButtonControl, {
        props: {
          name: props.name,
          checked: isChecked,
          disabled: props.disabled,
          readonly: props.readonly,
          error: !!props.error
        },
        on: {
          change() {
            if (data.on && data.on.change) {
              data.on.change(props.trueValue)
            }
          }
        }
      })
    ])
    return h(Choice, {
      props: {
        label: props.label,
        error: props.error,
        helpText: props.helpText,
        disabled: props.disabled,
        readonly: props.readonly
      },
      scopedSlots: {
        content() {
          if (isChecked && children) {
            return h('div', {
              class: $style.Content
            }, children)
          }
        }
      }
    }, [
      controlMarkup
    ])
  }
}
</script>

<style lang="scss" module>
.RadioButton {
  position: relative;
  width: 100%;
}

.Content {
  padding-left: 24px;
}
</style>
